export default {
  SET_PAGE: 'SET_PAGE'
}
